import React from "react";

export default function Option({
  name,
  value,
  form,
  setForm,
  showOptions,
  setShowOptions,
  children
}) {
  function handleClick() {
    setForm({ ...form, [name]: value });
    setShowOptions(!showOptions);
  }
  return (
    <div
      style={{
        backgroundColor: "rgb(255, 255, 245)",
        color: "rgba(0, 0, 0, .6)",
        fontSize: 16,
        marginBottom: value === "" ? ".5rem" : 0,
        paddingBottom: value === "" ? 0 : ".5rem",
        paddingLeft: value === "" ? 0 : ".5rem",
        textAlign: "left"
      }}
      onClick={handleClick}
      onKeyPress={(e) => (e.key === "Enter" ? handleClick() : null)}
      tabIndex="0"
    >
      {children}
    </div>
  );
}
